// extracted by mini-css-extract-plugin
export default {"button":"fy_dQ","isActive":"fy_hd","focus-visible":"fy_gR","focusVisible":"fy_gR","isNotInverted":"fy_n2","isFocused":"fy_nT","icon":"fy_js","tooltip":"fy_n3"};